module.exports = __webpack_public_path__ + "static/img/monitiornew6.03f6cc9c.png";